Controller = App.loadClass 'core::Angular/Controller'

class exports.VegetativeCoverController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service) ->
        super

        @service.onDataLoaded @scope, () =>
            if @service.fpcResult.data.manual_vegetative_cover?
                return

            @http.get "/backend/grower/fieldprint/default-vegetative-covers/#{@service.crop}/#{@service.field}/#{@service.fpcResult.data.management_system_filters?.fallTillage}/#{@service.fpcResult.data.management_system_filters?.coverCrop}"
            .then (response) =>
                @service.fpcResult.data.vegetative_covers = response.data

    setVegetativeCovers: (value) =>
        _.fill @service.fpcResult.data.vegetative_covers, value

    vegetativeCoverChanged: () =>
        @service.fpcResult.data.manual_vegetative_cover = true
